import commonHelper from '@/app/utility/common.helper.utility';
import appStrings from '@/app/utility/string.utility';
import distributedItcDetails from './distributedItcDetails';
import unReconcileData from './unReconcileData';
import reconcileData from './reconcileData';

export default {
  name: 'isdDistribution',
  props: ['rowData'],
  watch: {
    currentPage: function() {
      this.getIsdCreditDistributionData();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getIsdCreditDistributionData();
    },
    currentPage1: function() {
      this.getIsdCreditLineData();
    },
    perPage1: function() {
      this.currentPage1 = 1;
      this.getIsdCreditLineData();
    }
  },
  components: { distributedItcDetails, unReconcileData,reconcileData },
  data() {
    return {
      loader: false,
      vsetCode: null,
      showValueSetModal: false,
      parent_value_set_id: null,
      depVsetParam: null,
      currentPage: 1,
      totalRows: null,
      currentPage1: 1,
      totalRows1: null,
      perPage: commonHelper.perPageRecord,
      perPage1: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      financialYear: {
        text: null,
        value: null
      },
      gstn: {
        text: null,
        value: null
      },
      period: {
        text: null,
        value: null
      },
      legalEntity: {
        text: null,
        value: null
      },
      isdCreditDistributionData: [],
      isdCreditDistributionFields: [
        {
          key: 'RecipientGstn',
          label: ' Recipient GSTN',
          class: 'text-center'
        },
        {
          key: 'IgstRecoverable',
          label: 'IGST',
          class: 'text-center',
          variant: 'info'
        },
        {
          key: 'CgstRecoverable',
          label: 'CGST',
          class: 'text-center',
          variant: 'info'
        },
        {
          key: 'SgstRecoverable',
          label: 'SGST',
          class: 'text-center ',
          variant: 'info'
        },
        {
          key: 'IgstNonRecoverable',
          label: 'IGST-NR',
          class: 'text-center ',
          variant: 'secondary'
        },
        {
          key: 'CgstNonRecoverable',
          label: 'CGST-NR',
          class: 'text-center ',
          variant: 'secondary'
        },
        {
          key: 'SgstNonRecoverable',
          label: 'SGST-NR',
          class: 'text-center ',
          variant: 'secondary'
        }
      ],
      typeLabels: {
        RECO_1_EXCLUDED_N: 'Reconcile',
        'Non Reconcile': 'Un-Reconciled',
        RECO_1_EXCLUDED_Y: 'Excluded',
        Total: 'Total'
      },
      isdCreditData: [
        {
          type: 'Reconcile',
          label: 'Reconciles'
        },
        {
          type: 'Non Reconcile'
        },
        {
          type: 'Excluded'
        },
        {
          type: 'Total'
        }
      ],
      isdCreditFields: [
        {
          key: 'type',
          label: 'Type'
        },
        {
          key: 'igst_y',
          label: 'IGST',
          class: 'text-center ',
          variant: 'success'
        },
        {
          key: 'cgst_y',
          label: 'CGST',
          class: 'text-center',
          variant: 'success'
        },
        {
          key: 'sgst_y',
          label: 'SGST',
          class: 'text-center ',
          variant: 'success'
        },
        {
          key: 'igst_n',
          label: 'IGST',
          class: 'text-center ',
          variant: 'danger'
        },
        {
          key: 'cgst_n',
          label: 'CGST',
          class: 'text-center',
          variant: 'danger'
        },
        {
          key: 'sgst_n',
          label: 'SGST',
          class: 'text-center ',
          variant: 'danger'
        }
      ],
      showIsdDistributionDetailsModal: false,
      accessButtons: {
        deleteAllow: false,
        downloadAllow: false,
        uploadAllow: false,
        editAllow: true,
        addAllow: true,
        printAllow: false,
        approvalAllow: false
      },
      activeTab: 'distribution',
      isdCreditLineDistributionData: [],
      isdCreditLineDistributionFields: [
        {
          key: 'ExcludedFlag',
          label: 'Exclude',
          class: 'text-center'
        },
        {
          key: 'DistributedFlag',
          label: 'Distributed',
          class: 'text-center'
        },
        {
          key: 'OperatingUnit',
          label: 'Operating Unit',
          class: 'text-center'
        },
        {
          key: 'DocumentNum',
          label: 'Document Number',
          class: 'text-center'
        },
        {
          key: 'InvoiceNum',
          label: 'Invoice Number',
          class: 'text-center'
        },
        {
          key: 'TaxInvoiceNum',
          label: 'Tax Invoice Number',
          class: 'text-center'
        },
        {
          key: 'IsdGstn',
          label: 'ISD GSTN',
          class: 'text-center'
        },
        {
          key: 'TpGst',
          label: 'TP GSTN',
          class: 'text-center'
        },
        {
          key: 'VendorName',
          label: 'Vendor Name',
          class: 'text-center'
        },

        {
          key: 'InvoiceDate',
          label: 'Invoice Date',
          class: 'text-center'
        },
        {
          key: 'GlDate',
          label: 'GL Date',
          class: 'text-center'
        },
        {
          key: 'InvoiceAmount',
          label: 'Invoice Amount',
          class: 'text-center'
        },
        {
          key: 'TaxableAmount',
          label: 'Taxable Amount',
          class: 'text-center'
        },
        {
          key: 'TaxRatePercentage',
          label: 'Tax Rate Percentage',
          class: 'text-center'
        },
        {
          key: 'Igst',
          label: 'IGST',
          class: 'text-center'
        },
        {
          key: 'Cgst',
          label: 'CGST',
          class: 'text-center'
        },

        {
          key: 'Sgst',
          label: 'SGST',
          class: 'text-center'
        },

        {
          key: 'SacCode',
          label: 'SAC Code',
          class: 'text-center'
        }
      ],
      AggHdrId: null,
      editMode: false,
      specIsdGstnIndex: null,
      isdRecipientGstn: null,
      unsubscribe: null,
      excludedData: [],
      downloadPayload: null,
      downloadPayload1: null,
      freezeFlag: null,
      invoiceNumber: null,
      showIsdReconcileModal: false,
      showIsdUnReconcileModal:false
    };
  },
  mounted() {
    this.AggHdrId = this.rowData.AggHdrId;
    this.freezeFlag = this.rowData.DistFreezeFlag;
    this.getIsdCreditData();
    this.getIsdCreditDistributionData();
    this.getIsdCreditLineData();
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'update') {
          this.editMode = true;
        }
        if (actionName === 'save') {
          this.excludeLineData();
        }
      }
    });
  },

  methods: {
    openValueSetModal(vsetCode) {
      this.vsetCode = vsetCode;
      this.showValueSetModal = true;
      this.parent_value_set_id = null;
      this.depVsetParam = null;
      if (this.vsetCode === appStrings.VALUESETTYPE.ISD_GL_PERIOD) {
        this.parent_value_set_id = this.legalEntity.value;
        this.depVsetParam = this.financialYear.value;
      } else if (this.vsetCode === appStrings.VALUESETTYPE.GST_ISD_GSTN) {
        this.parent_value_set_id = null;
      }
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    selectedvalueSet(item) {
      if (this.vsetCode === appStrings.VALUESETTYPE.CUSTOM_FY) {
        this.financialYear = {
          text: item.value_code,
          value: item.value_code
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.GST_ISD_GSTN) {
        this.gstn = {
          text: item.value_code,
          value: item.value_code
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.LEGAL_ENTITY_LIST) {
        this.legalEntity = {
          text: item.org_name,
          value: item.value_set_dtl_id
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.ISD_GL_PERIOD) {
        this.period = {
          text: item.period_name,
          value: item.value_code
        };
      }
    },
    clearVsetValues(vsetCode) {
      this.parent_value_set_id = null;
      if (vsetCode === 'CUSTOM_FY') {
        this.financialYear = {
          text: null,
          value: null
        };
      } else if (vsetCode === 'GST_ISD_GSTN') {
        this.gstn = {
          text: null,
          value: null
        };
      } else if (vsetCode === 'LEGAL_ENTITY_LIST') {
        this.legalEntity = {
          text: null,
          value: null
        };
      } else if (vsetCode === 'ISD_GL_PERIOD ') {
        this.period = {
          text: null,
          value: null
        };
      } else if (vsetCode === 'invoiceNumber') {
        this.invoiceNumber = null;
      }
    },
    clearFilters() {
      this.financialYear = {
        text: null,
        value: null
      };
      this.gstn = {
        text: null,
        value: null
      };
      this.period = {
        text: null,
        value: null
      };
      this.legalEntity = {
        text: null,
        value: null
      };
      this.isdCreditData = [];
    },
    openIsdDistributionDetail(index) {
      this.specIsdGstnIndex = index;
      (this.isdRecipientGstn = this.isdCreditDistributionData[
        this.specIsdGstnIndex
      ].RecipientGstn),
        (this.showIsdDistributionDetailsModal = true);
    },
    showHideIsdDistributionDetailsModal(flag) {
      this.showIsdDistributionDetailsModal = flag;
    },

    getIsdCreditData() {
      const payload = {
        le_id: this.rowData.LeId,
        fp_gst: this.rowData.IsdGstn,
        dist_period: this.rowData.DistPeriodName,
        fin_year: this.rowData.FinYear
      };
      this.loader = true;
      this.$store
        .dispatch('isdRevenue/getIsdCreditData', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.isdCreditData = response.data.data;
            const data = this.isdCreditData;
            const desiredOrder = [
              'RECO_1_EXCLUDED_N',
              'Non Reconcile',
              'RECO_1_EXCLUDED_Y',
              'Total'
            ];
            const reordered = [];
            for (const type of desiredOrder) {
              for (const item of data) {
                if (item.type === type) {
                  reordered.push(item);
                }
              }
            }
            this.isdCreditData = reordered;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getIsdCreditDistributionData() {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        le_id: this.rowData.LeId,
        fp_gst: this.rowData.IsdGstn,
        dist_period: this.rowData.DistPeriodName,
        fin_year: this.rowData.FinYear
      };
      this.downloadPayload = payload;
      this.loader = true;
      this.$store
        .dispatch('isdRevenue/getIsdCreditDistributionData', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.isdCreditDistributionData = response.data.data.page;
            this.totalRows = response.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    selectedTab(tabValue) {
      this.activeTab = tabValue;
      if (tabValue === 'distribution') {
        this.getIsdCreditDistributionData();
      } else {
        this.getIsdCreditLineData();
      }
    },
    getIsdCreditLineData() {
      const payload = {
        _page: this.currentPage1 - 1,
        _limit: this.perPage1,
        agg_hdr_id: this.AggHdrId
      };
      this.downloadPayload1 = payload;
      this.loader = true;
      this.$store
        .dispatch('isdRevenue/getIsdCreditLineData', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.isdCreditLineDistributionData = response.data.data.page;
            this.totalRows1 = response.data.data.total_elements;
            this.isdCreditLineDistributionData.map(data => {
              data.ExcludedFlag = data.ExcludedFlag === 'Y' ? true : false;
              return data;
            });
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    excludeLineData() {
      const promt = confirm('Are you sure, you want to exclude data');
      if (promt) {
        this.postExcludeCreditLineData();
      }
    },

    onSelectChangeExclude(item) {
      for (let i of this.isdCreditLineDistributionData) {
        if (i.InvoiceNum === item.InvoiceNum) {
          if (item.ExcludedFlag === true) {
            i.ExcludedFlag = true;
          } else {
            i.ExcludedFlag = false;
          }
        }
      }
      this.excludeData = this.isdCreditLineDistributionData.map(item => {
        return {
          invoice_id: item.InvoiceId,
          excluded_flag: item.ExcludedFlag ? 'Y' : 'N'
        };
      });
    },
    postExcludeCreditLineData() {
      const payload = { params: this.excludeData };
      this.loader = true;
      this.$store
        .dispatch('isdRevenue/postExcludeCreditLineData', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.editMode = false;
            this.$bvToast.toast(response.data.message, {
              title: 'Alert',
              variant: 'success',
              solid: true
            });
            this.getIsdCreditLineData();
          }
        });
    },
    downloadDistributedData() {
      this.loader = true;
      const downloadpayload = { ...this.downloadPayload };
      downloadpayload._limit = this.totalRows;
      this.downloadExcel.downloadData(
        downloadpayload,
        'isdRevenue/getIsdCreditDistributionData',
        'UnDistributed ITC',
        () => (this.loader = false)
      );
    },
    downloadUnDistributedData() {
      this.loader = true;
      const downloadpayload = { ...this.downloadPayload1 };
      downloadpayload._limit = this.totalRows1;
      this.downloadExcel.downloadData(
        downloadpayload,
        'isdRevenue/getIsdCreditLineData',
        'Distributed ITC',
        () => (this.loader = false)
      );
    },
    lineDataByInvoiceNumber() {
      const payload = {
        invoice_num: this.invoiceNumber,
        agg_hdr_id: this.AggHdrId
      };
      this.loader = true;
      this.$store
        .dispatch('isdRevenue/getIsdCreditLineData', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.isdCreditLineDistributionData = response.data.data.page;
            this.totalRows1 = response.data.data.total_elements;
            this.isdCreditLineDistributionData.map(data => {
              data.ExcludedFlag = data.ExcludedFlag === 'Y' ? true : false;
              return data;
            });
          }
        });
    },
    clearByInvoiceNumber() {
      this.invoiceNumber = null;
      this.getIsdCreditLineData();
    },
    openIsdUnReconcileData() {
      this.showIsdUnReconcileModal = true;
    },
    openIsdReconcileData() {
      this.showIsdReconcileModal= true;
    },
    showHideIsdUnReconcileModal(flag) {
      this.showIsdUnReconcileModal = flag;
    },
     showHideIsdReconcileModal(flag) {
      this.showIsdReconcileModal = flag;
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
